/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
v3RegistrationApp.controller('resetPasswordCtrl', ['$scope', '$routeParams', '$window', '$filter', 'DebugHelper', 'UserManager', 'V3UsersResource', 'V3PasswordsResource', 'V3ModelHelper', function($scope, $routeParams, $window, $filter, DebugHelper, UserManager, V3UsersResource, V3PasswordsResource, V3ModelHelper) {
  DebugHelper.register("resetPasswordCtrl", $scope);

  _.assignIn($scope, {
    params: {},
    stateUI: {
      currentStep: "prompt",
      error: null
    },

    submitForm(form) {
      form.submitted = true;
      if (!form.$valid) { return; }

      return V3PasswordsResource.create($scope.params
      , success => $scope.stateUI.currentStep = "success"
      , function(error) {
        $scope.stateUI.error = V3ModelHelper.humanizeV3Error(error.data);
        // Maybe this should case on 404 or 422 and show different message
        $scope.stateUI.error = V3ModelHelper.humanizeV3Error(error.data);
        return $scope.stateUI.currentStep = "failure";
      });
    },

    submitResetForm(form) {
      form.submitted = true;
      if (!form.$valid) { return; }
      $scope.params.id = $routeParams.token;
      return V3PasswordsResource.update($scope.params
      , success => $window.location.href = Packs.iKnowRoutes.v3_dashboard_path()
      , error => $scope.stateUI.error = V3ModelHelper.humanizeV3Error(error.data));
    }
  }
  );

  V3PasswordsResource.get({id: $routeParams.token}
  , function(success) {
    $scope.user = V3ModelHelper.parse(success);
    return $scope.passwordMinLength = success.meta['min-password-length'];
});

  return document.title = $filter("translate")("js.registrations.forgot_password.title") + " | Cerego";
}
]);
